import { LIMPAR_ITINERARIOS } from '../types'

export default function limparTrechos () {
  return {
    type: LIMPAR_ITINERARIOS,
  }
}
